module.exports = __webpack_public_path__ + "static/media/footerLogo.4f601bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/footerLogo.png
// module id = 192
// module chunks = 0